import React from 'react';

import { CorporateSubscriberCirclePartner } from '../../utils/backend-api/partners';
import { isExternalURL } from '../../utils/url_validations';
import { Button } from '../BaseUI';

interface CorporateSubscriberCircleCardProps {
  partner: CorporateSubscriberCirclePartner;
}

const CorporateSubscriberCircleCard = ({ partner }: CorporateSubscriberCircleCardProps) => {
  const { id, name, tagline, targetLink } = partner;
  const externalLinkAttributes = isExternalURL(targetLink, window.location)
    ? { target: '_blank', rel: 'sponsored' }
    : {};

  return (
    <div className="tw-text-zinc-800 tw-text-[14px] tw-font-['Meta',Georgia,sans-serif] tw-pl-12 tw-py-3 tw-mb-8 tw-border-0 tw-border-l tw-border-[#c4c6ce] tw-border-solid">
      <Button
        href={targetLink}
        variant="link"
        trackClick
        trackingProps={{
          name: 'csc_card',
          identifier: id.toString(),
        }}
        {...externalLinkAttributes}
      >
        {name}: {tagline}
      </Button>
    </div>
  );
};

export default CorporateSubscriberCircleCard;
